export default __webpack_public_path__ + "static/media/iRead_23_1.7e73fd28.jpeg";